import React from "react";

// Section C (admin-only): a plain ordered list of footnote text entries —
// add, edit, remove, reorder by deleting and re-adding. Shared by
// ArticleFormPage.js, TopicFormPage.js, and IssueTopicFormPage.js so every
// content type gets book-style numbered endnotes the same way.
function FootnotesEditor({ footnotes, onChange }) {
  function handleChange(index, value) {
    const next = [...footnotes];
    next[index] = value;
    onChange(next);
  }

  function handleRemove(index) {
    onChange(footnotes.filter((_, i) => i !== index));
  }

  function handleAdd() {
    onChange([...footnotes, ""]);
  }

  return (
    <div className="footnotes-editor">
      {footnotes.map((note, index) => (
        <div className="footnotes-editor-row" key={index}>
          <span className="footnotes-editor-index">{index + 1}</span>
          <textarea
            rows={2}
            value={note}
            onChange={(e) => handleChange(index, e.target.value)}
            placeholder="متن پانویس..."
          />
          <button
            type="button"
            className="footnotes-editor-remove"
            onClick={() => handleRemove(index)}
            aria-label="حذف این پانویس"
          >
            ×
          </button>
        </div>
      ))}

      <button type="button" className="footnotes-editor-add" onClick={handleAdd}>
        + افزودن پانویس
      </button>
    </div>
  );
}

export default FootnotesEditor;
